
import EventBusConstants from '@/constants/EventBusConstants';
import NavigationDirectionEnum from '@/controllers/navigation/NavigationDirectionEnum';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import TestController from '@/controllers/TestController';
import PlayerEmitter from '@/event/PlayerEmitter';
import { inject } from 'vue';
import { Vue } from 'vue-property-decorator';
export default class FocusModeNavigationControl extends Vue {
  private testController: TestController | undefined = inject<TestController>('testController');
  private playerEmitter: PlayerEmitter | undefined = inject<PlayerEmitter>('playerEmitter');
  private sectionLockEnabled = false;

  mounted() {
    this.sectionLockEnabled = this.testController
      ? this.testController.deliveryOptionEnabledForTest(DeliveryOptionConstants.BLOCK_RETURN_TO_SECTION)
      : false;
  }

  private get previousDisabled(): boolean {
    return !this.testController!.navigationController?.previousAvailable();
  }

  private previousButtonClicked(): void {
    this.playerEmitter!.emit(EventBusConstants.NAVIGATION_EVENT, [['direction', NavigationDirectionEnum.Back]]);
  }

  private nextButtonClicked(): void {
    this.playerEmitter!.emit(
      EventBusConstants.NAVIGATION_EVENT,
      new Map<string, NavigationDirectionEnum>([['direction', NavigationDirectionEnum.Forward]])
    );
  }
}
